"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.onEnter = void 0;
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageUiNav_sidecar_1 = require("@voyage/ui/voyageUiNav-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
function onEnter(obj) {
    if (voyagePicker_sidecar_1.voyagePicker.get().selectedCrew === obj) {
        // voyageUiNav.setOpen(true)
    }
}
exports.onEnter = onEnter;
function onLeave(obj) {
    voyageUiNav_sidecar_1.voyageUiNav.setOpen(false);
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    if (voyageUiNav_sidecar_1.voyageUiNav.get().isOpen) {
        voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
    }
    else {
        // voyageUiSubsystem.setOpen(true, obj.tile)
    }
}
exports.onSelectedCrewOn = onSelectedCrewOn;
